import { InvoicesPermissions } from "./financial-management.invoices.permissions";

export class FinancialManagementPermissions {
  static Invoices = InvoicesPermissions?.Permissions;
}

export function getFinancialManagementModuleName() {
  return 'FinancialManagement';
}